import { ScheduleWithDates } from 'types/interfaces';

export const PickerScheduleTemplate: ScheduleWithDates = {
  id: 0,
  scheduleId: 0,
  startDate: '',
  endDate: '',
  name: ''
};
